import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

var GridNavigationDirection;
(function(GridNavigationDirection) {
    GridNavigationDirection["UP"] = 'up';
    GridNavigationDirection["DOWN"] = 'down';
    GridNavigationDirection["LEFT"] = 'left';
    GridNavigationDirection["RIGHT"] = 'right';
})(GridNavigationDirection || (GridNavigationDirection = {}));
function useGridNavigation(isActive, grid, targetElement, close) {
    React.useEffect(()=>{
        function handleKeyDownEvent(event) {
            switch(event.key){
                case 'Down':
                case 'ArrowDown':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.DOWN
                    });
                    break;
                case 'Up':
                case 'ArrowUp':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.UP
                    });
                    break;
                case 'Left':
                case 'ArrowLeft':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.LEFT
                    });
                    break;
                case 'Right':
                case 'ArrowRight':
                    event.preventDefault();
                    dispatch({
                        type: GridNavigationDirection.RIGHT
                    });
                    break;
                case 'Esc':
                case 'Escape':
                    close();
                    break;
            }
        }
        const target = targetElement.current;
        if (isActive && target) {
            target.addEventListener('keydown', handleKeyDownEvent, false);
            return ()=>target.removeEventListener('keydown', handleKeyDownEvent, false)
            ;
        }
    }, [
        isActive,
        targetElement.current
    ]);
    const [state, dispatch] = React.useReducer(navigationReducer, {
        colIndex: 0,
        rowIndex: 0,
        grid
    });
    function setState(rowIndex, colIndex) {
        dispatch({
            type: 'SET',
            payload: {
                rowIndex,
                colIndex
            }
        });
    }
    return [
        {
            colIndex: state.colIndex,
            rowIndex: state.rowIndex
        },
        setState
    ];
}
function navigationReducer(state, action) {
    switch(action.type){
        case GridNavigationDirection.UP:
            {
                const rowIndex = state.rowIndex - 1;
                if (rowIndex < 0) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, {
                    rowIndex
                });
            }
        case GridNavigationDirection.DOWN:
            {
                const rowIndex = state.rowIndex + 1;
                const column = state.grid[state.colIndex];
                if (!column || rowIndex >= column) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, {
                    rowIndex
                });
            }
        case GridNavigationDirection.LEFT:
            {
                const colIndex = state.colIndex - 1;
                if (colIndex < 0) {
                    return state // Out of bounds, no movement
                    ;
                }
                const column = state.grid[colIndex];
                if (!column) {
                    return state // No valid column at colIndex
                    ;
                }
                const newState = swcHelpers.objectSpread({}, state, {
                    colIndex
                });
                if (state.rowIndex >= column) {
                    newState.rowIndex = column - 1 // Adjust rowIndex to stay within bounds
                    ;
                }
                return newState;
            }
        case GridNavigationDirection.RIGHT:
            {
                const colIndex = state.colIndex + 1;
                // Check if colIndex is within bounds
                if (colIndex >= state.grid.length) {
                    return state // No movement if out of bounds
                    ;
                }
                const column = state.grid[colIndex];
                if (!column) {
                    return state // No valid column at colIndex
                    ;
                }
                const newState = swcHelpers.objectSpread({}, state, {
                    colIndex
                });
                // Ensure rowIndex stays within the bounds of the new column
                if (state.rowIndex >= column) {
                    newState.rowIndex = column - 1;
                }
                return newState;
            }
        case 'SET':
            {
                const { colIndex , rowIndex  } = action.payload;
                // Ensure colIndex is within bounds of the grid
                if (colIndex >= state.grid.length) {
                    return state // Invalid column
                    ;
                }
                const column = state.grid[colIndex];
                if (!column || rowIndex >= column) {
                    return state // Invalid row for the column
                    ;
                }
                return swcHelpers.objectSpread({}, state, action.payload);
            }
        default:
            {
                throw new Error();
            }
    }
}

export { GridNavigationDirection, navigationReducer, useGridNavigation };
//# sourceMappingURL=useGridNavigation.js.map
